import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=84352a96&scoped=true&"
import script from "./userInfo.vue?vue&type=script&lang=ts&"
export * from "./userInfo.vue?vue&type=script&lang=ts&"
import style0 from "./userInfo.scss?vue&type=style&index=0&id=84352a96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84352a96",
  null
  
)

export default component.exports